// extracted by mini-css-extract-plugin
export default {"round":"Round_round__RpxW5"};